// sections/PaymentMethodSection/rowClasses.ts — Style baris + slot logo (1 file).
import React from 'react';
import QRIcon from '../../../../components/icons/QRIcon';
import BankTransferIcon from '../../../../components/icons/BankTransferIcon';

export const ROW_BASE = 'px-1 py-2.5 flex items-center gap-3 cursor-pointer transition-colors ';
export const ROW_IDLE = '';
export const ROW_ACTIVE = 'bg-orange-50/60 dark:bg-orange-900/20';

// Slot LEBAR TETAP: logo ukuran natural rata kiri, semua nama sejajar.
// JANGAN paksa kotak (landscape gepeng blur) — tinggi seragam, lebar ikut aspek.
export const LOGO_SLOT = 'w-[72px] shrink-0 flex items-center justify-start';

type IconFC = React.FC<{ className?: string }>;

export const duitkuIconClass = (Icon: IconFC) =>
    (Icon === QRIcon || Icon === BankTransferIcon)
        ? 'w-6 h-6 text-slate-600 dark:text-slate-300'
        : 'h-6 w-auto max-w-full object-contain';

export const stdIconClass = (Icon: IconFC) =>
    (Icon === BankTransferIcon)
        ? 'w-6 h-6 text-slate-600 dark:text-slate-300'
        : 'h-6 w-auto max-w-full object-contain';
